import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { afterSystem, beforeSystem } from '../../data/content';

/** Section 3 — from chaos to one organized system. */
export function TransformationSection() {
  return <section aria-labelledby="transformation-heading" className="bg-brand-lavender px-5 py-16 lg:px-8 lg:py-24" data-id="element-177" data-mp="3q5r9nsooz2kv">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="3b7yzzh5tt8el">
        <SectionHeading id="transformation-heading" title={<>
              Imagine Opening ONE System and <Accent data-id="element-180" data-mp="3g579yugtm64r">Knowing Exactly Where to Start.</Accent>
            </>} data-id="element-179" data-mp="3b6xd8ffg6xh1" />

        <div className="mt-14 grid items-stretch gap-6 md:grid-cols-2" data-id="element-181" data-mp="32a558anpmmtj">
          <div className="rounded-[20px] border border-brand-charcoal/12 bg-white/60 px-6 py-8 sm:px-8" data-id="element-182" data-mp="3775awkgndnk4">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-183" data-mp="10h73fpbygjwg">
              Before Makeup Instructor Ready
            </p>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-184" data-mp="mut19enahh8e">
              {beforeSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-185" data-mp="itqy4mq94l15">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-brand-charcoal/35" strokeWidth={2} aria-hidden="true" data-id="element-186" data-mp="wl5jh07msybd" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] bg-brand-plum-dark px-6 py-8 text-white shadow-[0_30px_60px_-30px_rgba(59,27,87,0.7)] sm:px-8" data-id="element-187" data-mp="3z2znsj9qmv1">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-lilac" data-id="element-188" data-mp="dvpiycvy55uy">
              With Makeup Instructor Ready
            </p>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-189" data-mp="8yp8zqvz7iyk">
              {afterSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-white" data-id="element-190" data-mp="1kbi2b64f0fgq">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-191" data-mp="1sch86r2qwsci">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-192" data-mp="1wcrg49a3lsu0" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-14 text-center font-display text-[2.2rem] font-bold leading-[1.05] text-brand-charcoal sm:text-[3rem]" data-id="element-193" data-mp="26b796hsorc65">
          Less Time Preparing. <Accent data-id="element-194" data-mp="1dmrujwdguvvc">More Time Teaching.</Accent>
        </p>
      </div>
    </section>;
}